<div class="table-row">
    <div id="toggler" class="row py-2 align-items-center" (click)="toggleExpandEvent.emit()">
        <div class="col-1 limited-col-width">
            <fa-icon [icon]="isExpanded ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
        </div>
        <div class="col-5">
            <span class="col-3 text-wrap text-break">{{ selectedAddress.addrText.value || address.name1.value }}</span>
        </div>
        <div class="col-3 text-wrap text-break">{{ selectedAddress.city.value || address.city.value }}</div>
        <div class="col-2">
            <button
                class="btn btn-primary"
                type="button"
                [disabled]="!selectedAddress.isValid() || addressFormGroup.invalid"
                (click)="$event.stopPropagation(); selectAddress()"
                translate="TIMESHEET_SELECT_ADDRESS_LABEL"
            ></button>
        </div>
    </div>
    @if (isExpanded) {
        <div class="py-3">
            <div class="row align-items-center">
                @if (addressFormGroup) {
                    <form [formGroup]="addressFormGroup">
                        <fieldset [disabled]="!isEditable">
                            <div class="row mb-3">
                                <label
                                    class="col-12 col-md-3 col-form-label text-start text-md-end"
                                    translate="TIMESHEET_ADDRESS_TEXT"
                                ></label>
                                <div class="col-12 col-md-8">
                                    <pace-core-text-input
                                        [model]="displayAddressText"
                                        (modelChange)="selectedAddress.addrText = $event"
                                        [parentForm]="addressFormChildren"
                                        (valueChange)="onAddressChange()"
                                        [ariaLabel]="'TIMESHEET_ADDRESS_TEXT' | translate"
                                    ></pace-core-text-input>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <label
                                    class="col-12 col-md-3 col-form-label text-start text-md-end"
                                    translate="TIMESHEET_ADDRESS_STREET_TEXT"
                                ></label>
                                <div class="col-12 col-md-8">
                                    <pace-core-text-input
                                        [(model)]="selectedAddress.street"
                                        [parentForm]="addressFormChildren"
                                        (valueChange)="onAddressChange()"
                                        [ariaLabel]="'TIMESHEET_ADDRESS_STREET_TEXT' | translate"
                                    ></pace-core-text-input>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <label
                                    class="col-12 col-md-3 col-form-label text-start text-md-end"
                                    translate="TIMESHEET_ADDRESS_POSTCODE_TEXT"
                                ></label>
                                <div class="col-12 col-md-8">
                                    <pace-core-text-input
                                        [(model)]="selectedAddress.postCode"
                                        [parentForm]="addressFormChildren"
                                        (valueChange)="onAddressChange()"
                                        [ariaLabel]="'TIMESHEET_ADDRESS_POSTCODE_TEXT' | translate"
                                    ></pace-core-text-input>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <label
                                    class="col-12 col-md-3 col-form-label text-start text-md-end"
                                    translate="TIMESHEET_ADDRESS_CITY_TEXT"
                                ></label>
                                <div class="col-12 col-md-8">
                                    <pace-core-text-input
                                        [(model)]="selectedAddress.city"
                                        [parentForm]="addressFormChildren"
                                        (valueChange)="onAddressChange()"
                                        [ariaLabel]="'TIMESHEET_ADDRESS_CITY_TEXT' | translate"
                                    ></pace-core-text-input>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <label
                                    class="col-12 col-md-3 col-form-label text-start text-md-end"
                                    translate="TIMESHEET_ADDRESS_COUNTRY_TEXT"
                                ></label>
                                <div class="col-12 col-md-8">
                                    <pace-core-text-input
                                        [(model)]="selectedAddress.country"
                                        [parentForm]="addressFormChildren"
                                        (valueChange)="onAddressChange()"
                                        [ariaLabel]="'TIMESHEET_ADDRESS_COUNTRY_TEXT' | translate"
                                    ></pace-core-text-input>
                                </div>
                            </div>
                            @if (selectedAddress.statesOfUSA) {
                                <div class="row mb-3">
                                    <label
                                        class="col-12 col-md-3 col-form-label text-start text-md-end"
                                        translate="TIMESHEET_ADDRESS_STATE_LABEL"
                                    ></label>
                                    <div class="col-12 col-md-8">
                                        <pace-core-dropdown
                                            [(model)]="selectedAddress.statesOfUSA"
                                            [parentForm]="addressFormChildren"
                                            (valueChange)="onAddressChange()"
                                        ></pace-core-dropdown>
                                    </div>
                                </div>
                            }
                        </fieldset>
                    </form>
                }
                <div class="col-auto ms-auto">
                    @if ((enableHideTimesheetAddress && address.allowToHide) || allowToDelete) {
                        <button
                            class="btn btn-light me-3"
                            (click)="openHelp()"
                            [attr.aria-label]="'TIMESHEET_ADDRESS_HELP_BUTTON_LABEL' | translate"
                        >
                            <fa-icon [icon]="faQuestion"></fa-icon>
                        </button>
                    }
                    @if (enableHideTimesheetAddress && address.allowToHide) {
                        <button
                            class="btn btn-warning me-2"
                            (click)="hideAddress()"
                            [attr.aria-label]="'TIMESHEET_ADDRESS_HIDE_ADDRESS_BUTTON_LABEL' | translate"
                        >
                            <fa-icon [icon]="faEyeSlash"></fa-icon>
                        </button>
                    }
                    @if (allowToDelete) {
                        <button
                            class="btn btn-warning me-2"
                            (click)="deleteAddress()"
                            [attr.aria-label]="'TIMESHEET_ADDRESS_DELETE_ADDRESS_BUTTON_LABEL' | translate"
                        >
                            <fa-icon [icon]="faTrashAlt"></fa-icon>
                        </button>
                    }
                </div>
            </div>
        </div>
    }
</div>
